'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Typography = require('@material-ui/core/Typography');
var Grid = require('@material-ui/core/Grid');
var Dialog = require('@material-ui/core/Dialog');
var DialogContent = require('@material-ui/core/DialogContent');
var CircleLoader = require('../CircleLoader/CircleLoader.js');
var LoaderContext = require('./LoaderContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);
var Dialog__default = /*#__PURE__*/_interopDefaultLegacy(Dialog);
var DialogContent__default = /*#__PURE__*/_interopDefaultLegacy(DialogContent);

var LoaderProvider = _ref => {
  var {
    children
  } = _ref;
  var [isOpen, setIsOpen] = React__default['default'].useState(false);
  var [message, setMessage] = React__default['default'].useState('');
  var close = React__default['default'].useCallback(() => setIsOpen(false), []);
  var open = React__default['default'].useCallback(messageValue => {
    setMessage(messageValue);
    setIsOpen(true);
  }, []);
  var clearMessage = React__default['default'].useCallback(() => {
    if (!isOpen) {
      setMessage('');
    }
  }, [isOpen]);
  return /*#__PURE__*/React__default['default'].createElement(LoaderContext.LoaderContext.Provider, {
    value: {
      open,
      close
    }
  }, children, /*#__PURE__*/React__default['default'].createElement(Dialog__default['default'], {
    fullWidth: false,
    disableEscapeKeyDown: true,
    open: isOpen,
    TransitionProps: {
      mountOnEnter: true,
      unmountOnExit: true,
      onExited: clearMessage
    }
  }, /*#__PURE__*/React__default['default'].createElement(DialogContent__default['default'], null, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, /*#__PURE__*/React__default['default'].createElement(CircleLoader.CircleLoader, {
    size: 64
  })), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "subtitle1",
    color: "textSecondary"
  }, message))))));
};
LoaderProvider.propTypes = {
  children: index.node
};

exports.LoaderProvider = LoaderProvider;
exports.default = LoaderProvider;
